import {
  advisorSearch,
  simpleAdvisorSearch,
  simpleAdvisorPaymentSearch,
  advisorAppointmentSearch
} from "@/api/search.service";

export const useAdvisorSearch = () => {
  return {
    itemTitle: i => [i.name, i.email].filter(Boolean).join(" · "),
    comparisonValue: v => `${v.id}-${v.type}`,
    fetchResults: async (search, searchArgs) => {
      let searchFunc = advisorSearch;
      if (searchArgs.payment) {
        searchFunc = simpleAdvisorPaymentSearch;
      } else if (searchArgs.simple) {
        searchFunc = simpleAdvisorSearch;
      } else if (searchArgs.appointment) {
        searchFunc = value =>
          advisorAppointmentSearch(value, searchArgs.productId);
      } else if (searchArgs.employee) {
        searchFunc = value => advisorSearch(value, { employee: true });
      }
      return searchFunc(search);
    }
  };
};
